module.exports = __webpack_public_path__ + "media/images/soar/en/googlePlay-f9941b67f1f2d4c51363c412f7382fc0.png";